import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_3d278f32 from 'nuxt_plugin_plugin_3d278f32' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_libplugin757e43bd_5e885a74 from 'nuxt_plugin_libplugin757e43bd_5e885a74' // Source: ./lib.plugin.757e43bd.js (mode: 'all')
import nuxt_plugin_vuemq_0a5fe3e0 from 'nuxt_plugin_vuemq_0a5fe3e0' // Source: ./vue-mq.js (mode: 'all')
import nuxt_plugin_pluginsvueutils6c24288c_8d46426e from 'nuxt_plugin_pluginsvueutils6c24288c_8d46426e' // Source: ./plugins.vue-utils.6c24288c.js (mode: 'all')
import nuxt_plugin_toast_003ad2ac from 'nuxt_plugin_toast_003ad2ac' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_340a85fd from 'nuxt_plugin_axios_340a85fd' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_63a301de from 'nuxt_plugin_pluginutils_63a301de' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_862ae0ae from 'nuxt_plugin_pluginrouting_862ae0ae' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b218b734 from 'nuxt_plugin_pluginmain_b218b734' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4d3a8ba5 from 'nuxt_plugin_cookieuniversalnuxt_4d3a8ba5' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vueauth_16e5f44c from 'nuxt_plugin_vueauth_16e5f44c' // Source: ./vue-auth.js (mode: 'client')
import nuxt_plugin_vuesocialauth_64c5d952 from 'nuxt_plugin_vuesocialauth_64c5d952' // Source: ./vue-social-auth.js (mode: 'client')
import nuxt_plugin_router_0192c552 from 'nuxt_plugin_router_0192c552' // Source: ./router.js (mode: 'all')
import nuxt_plugin_deviceplugin_98225ef0 from 'nuxt_plugin_deviceplugin_98225ef0' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_455d204e from 'nuxt_plugin_workbox_455d204e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_17cdcdec from 'nuxt_plugin_metaplugin_17cdcdec' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_1c757360 from 'nuxt_plugin_iconplugin_1c757360' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_vuestripe_03930b4d from 'nuxt_plugin_vuestripe_03930b4d' // Source: ../plugins/vue-stripe.js (mode: 'client')
import nuxt_plugin_vueslidercomponent_c19e4b6e from 'nuxt_plugin_vueslidercomponent_c19e4b6e' // Source: ../plugins/vue-slider-component.js (mode: 'client')
import nuxt_plugin_vuehelpers_30b8f0ef from 'nuxt_plugin_vuehelpers_30b8f0ef' // Source: ../plugins/vue-helpers.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_vshowslide_e4e887ae from 'nuxt_plugin_vshowslide_e4e887ae' // Source: ../plugins/v-show-slide.js (mode: 'all')
import nuxt_plugin_vtooltip_3d258741 from 'nuxt_plugin_vtooltip_3d258741' // Source: ../plugins/v-tooltip.js (mode: 'client')
import nuxt_plugin_vuejstogglebutton_4c83415a from 'nuxt_plugin_vuejstogglebutton_4c83415a' // Source: ../plugins/vue-js-toggle-button.js (mode: 'client')
import nuxt_plugin_vueevents_10ad4701 from 'nuxt_plugin_vueevents_10ad4701' // Source: ../plugins/vue-events.js (mode: 'all')
import nuxt_plugin_vuejsmodal_a01fef9e from 'nuxt_plugin_vuejsmodal_a01fef9e' // Source: ../plugins/vue-js-modal.js (mode: 'client')
import nuxt_plugin_vuejsdialog_5a3b7a7b from 'nuxt_plugin_vuejsdialog_5a3b7a7b' // Source: ../plugins/vuejs-dialog.js (mode: 'client')
import nuxt_plugin_vueinlinesvg_56f4a20a from 'nuxt_plugin_vueinlinesvg_56f4a20a' // Source: ../plugins/vue-inline-svg.js (mode: 'all')
import nuxt_plugin_vueacl_4a12896c from 'nuxt_plugin_vueacl_4a12896c' // Source: ../plugins/vue-acl.js (mode: 'all')
import nuxt_plugin_vuehttp_13bc89f2 from 'nuxt_plugin_vuehttp_13bc89f2' // Source: ../plugins/vue-http.js (mode: 'all')
import nuxt_plugin_laravelvuepagination_00661f4c from 'nuxt_plugin_laravelvuepagination_00661f4c' // Source: ../plugins/laravel-vue-pagination.js (mode: 'all')
import nuxt_plugin_vueleaflet2_28671805 from 'nuxt_plugin_vueleaflet2_28671805' // Source: ../plugins/vue-leaflet2.js (mode: 'client')
import nuxt_plugin_vueslickcarousel_1c6345a5 from 'nuxt_plugin_vueslickcarousel_1c6345a5' // Source: ../plugins/vue-slick-carousel.js (mode: 'client')
import nuxt_plugin_vueperfectscrollbar_4f61232e from 'nuxt_plugin_vueperfectscrollbar_4f61232e' // Source: ../plugins/vue-perfect-scrollbar.js (mode: 'client')
import nuxt_plugin_vuetippy_1467d320 from 'nuxt_plugin_vuetippy_1467d320' // Source: ../plugins/vue-tippy.js (mode: 'all')
import nuxt_plugin_swupdate_eb7c824a from 'nuxt_plugin_swupdate_eb7c824a' // Source: ../plugins/sw-update.js (mode: 'client')
import nuxt_plugin_vuepwainstall_71e6e7e8 from 'nuxt_plugin_vuepwainstall_71e6e7e8' // Source: ../plugins/vue-pwa-install.js (mode: 'client')
import nuxt_plugin_vuesmoothscroll_867b4ef0 from 'nuxt_plugin_vuesmoothscroll_867b4ef0' // Source: ../plugins/vue-smooth-scroll.js (mode: 'client')
import nuxt_plugin_mapbox_80e2041c from 'nuxt_plugin_mapbox_80e2041c' // Source: ../plugins/mapbox.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"ESSE","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x15","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","color":"#5bbad5","href":"\u002Fsafari-pinned-tab.svg"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@400;500;600&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fapi.tiles.mapbox.com\u002Fmapbox-gl-js\u002Fv2.10.0\u002Fmapbox-gl.css"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F12.9__iPad_Pro_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F11__iPad_Pro__10.5__iPad_Pro_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F10.9__iPad_Air_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F10.5__iPad_Air_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F10.2__iPad_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F9.7__iPad_Pro__7.9__iPad_mini__9.7__iPad_Air__9.7__iPad_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"\u002FiPhone_14_Pro_Max__iPhone_14_Max__iPhone_13_Pro_Max__iPhone_12_Pro_Max_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"\u002FiPhone_14_Pro__iPhone_14__iPhone_13_Pro__iPhone_13__iPhone_12_Pro__iPhone_12_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"\u002FiPhone_13_mini__iPhone_12_mini__iPhone_11_Pro__iPhone_XS__iPhone_X_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"\u002FiPhone_11_Pro_Max__iPhone_XS_Max_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002FiPhone_11__iPhone_XR_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"\u002FiPhone_8_Plus__iPhone_7_Plus__iPhone_6s_Plus__iPhone_6_Plus_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002FiPhone_8__iPhone_7__iPhone_6s__iPhone_6__4.7__iPhone_SE_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","href":"\u002F4__iPhone_SE__iPod_touch_5th_generation_and_later_landscape.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F12.9__iPad_Pro_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F11__iPad_Pro__10.5__iPad_Pro_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 820px) and (device-height: 1180px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F10.9__iPad_Air_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F10.5__iPad_Air_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F10.2__iPad_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F9.7__iPad_Pro__7.9__iPad_mini__9.7__iPad_Air__9.7__iPad_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","href":"\u002FiPhone_14_Pro_Max__iPhone_14_Max__iPhone_13_Pro_Max__iPhone_12_Pro_Max_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","href":"\u002FiPhone_14_Pro__iPhone_14__iPhone_13_Pro__iPhone_13__iPhone_12_Pro__iPhone_12_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","href":"\u002FiPhone_13_mini__iPhone_12_mini__iPhone_11_Pro__iPhone_XS__iPhone_X_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","href":"\u002FiPhone_11_Pro_Max__iPhone_XS_Max_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002FiPhone_11__iPhone_XR_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","href":"\u002FiPhone_8_Plus__iPhone_7_Plus__iPhone_6s_Plus__iPhone_6_Plus_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002FiPhone_8__iPhone_7__iPhone_6s__iPhone_6__4.7__iPhone_SE_portrait.png"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","href":"\u002F4__iPhone_SE__iPod_touch_5th_generation_and_later_portrait.png"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3d278f32 === 'function') {
    await nuxt_plugin_plugin_3d278f32(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin757e43bd_5e885a74 === 'function') {
    await nuxt_plugin_libplugin757e43bd_5e885a74(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemq_0a5fe3e0 === 'function') {
    await nuxt_plugin_vuemq_0a5fe3e0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsvueutils6c24288c_8d46426e === 'function') {
    await nuxt_plugin_pluginsvueutils6c24288c_8d46426e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_003ad2ac === 'function') {
    await nuxt_plugin_toast_003ad2ac(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_340a85fd === 'function') {
    await nuxt_plugin_axios_340a85fd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_63a301de === 'function') {
    await nuxt_plugin_pluginutils_63a301de(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_862ae0ae === 'function') {
    await nuxt_plugin_pluginrouting_862ae0ae(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_b218b734 === 'function') {
    await nuxt_plugin_pluginmain_b218b734(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4d3a8ba5 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4d3a8ba5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueauth_16e5f44c === 'function') {
    await nuxt_plugin_vueauth_16e5f44c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialauth_64c5d952 === 'function') {
    await nuxt_plugin_vuesocialauth_64c5d952(app.context, inject)
  }

  if (typeof nuxt_plugin_router_0192c552 === 'function') {
    await nuxt_plugin_router_0192c552(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_98225ef0 === 'function') {
    await nuxt_plugin_deviceplugin_98225ef0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_455d204e === 'function') {
    await nuxt_plugin_workbox_455d204e(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_17cdcdec === 'function') {
    await nuxt_plugin_metaplugin_17cdcdec(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_1c757360 === 'function') {
    await nuxt_plugin_iconplugin_1c757360(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestripe_03930b4d === 'function') {
    await nuxt_plugin_vuestripe_03930b4d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslidercomponent_c19e4b6e === 'function') {
    await nuxt_plugin_vueslidercomponent_c19e4b6e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehelpers_30b8f0ef === 'function') {
    await nuxt_plugin_vuehelpers_30b8f0ef(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_vshowslide_e4e887ae === 'function') {
    await nuxt_plugin_vshowslide_e4e887ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_3d258741 === 'function') {
    await nuxt_plugin_vtooltip_3d258741(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejstogglebutton_4c83415a === 'function') {
    await nuxt_plugin_vuejstogglebutton_4c83415a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueevents_10ad4701 === 'function') {
    await nuxt_plugin_vueevents_10ad4701(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_a01fef9e === 'function') {
    await nuxt_plugin_vuejsmodal_a01fef9e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsdialog_5a3b7a7b === 'function') {
    await nuxt_plugin_vuejsdialog_5a3b7a7b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinlinesvg_56f4a20a === 'function') {
    await nuxt_plugin_vueinlinesvg_56f4a20a(app.context, inject)
  }

  if (typeof nuxt_plugin_vueacl_4a12896c === 'function') {
    await nuxt_plugin_vueacl_4a12896c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuehttp_13bc89f2 === 'function') {
    await nuxt_plugin_vuehttp_13bc89f2(app.context, inject)
  }

  if (typeof nuxt_plugin_laravelvuepagination_00661f4c === 'function') {
    await nuxt_plugin_laravelvuepagination_00661f4c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueleaflet2_28671805 === 'function') {
    await nuxt_plugin_vueleaflet2_28671805(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueslickcarousel_1c6345a5 === 'function') {
    await nuxt_plugin_vueslickcarousel_1c6345a5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueperfectscrollbar_4f61232e === 'function') {
    await nuxt_plugin_vueperfectscrollbar_4f61232e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetippy_1467d320 === 'function') {
    await nuxt_plugin_vuetippy_1467d320(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swupdate_eb7c824a === 'function') {
    await nuxt_plugin_swupdate_eb7c824a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepwainstall_71e6e7e8 === 'function') {
    await nuxt_plugin_vuepwainstall_71e6e7e8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesmoothscroll_867b4ef0 === 'function') {
    await nuxt_plugin_vuesmoothscroll_867b4ef0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapbox_80e2041c === 'function') {
    await nuxt_plugin_mapbox_80e2041c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
